import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {NameInput} from "../components/NameInput";
import {DateInput} from "../components/DateInput";
import {GenreInput} from "../components/GenreInput";
import {PhoneInput} from "../components/PhoneInput";
import {EmailInput} from "../components/EmailInput";
import Card from "../components/Card";

const cardsImages = {
    0: "https://astrologyytoday2024.com/images/c-0.jpeg",
    1: "https://astrologyytoday2024.com/images/c-1.jpeg",
    2: "https://astrologyytoday2024.com/images/c-2.jpeg",
    3: "https://astrologyytoday2024.com/images/c-3.jpeg",
    4: "https://astrologyytoday2024.com/images/c-4.jpeg",
    5: "https://astrologyytoday2024.com/images/c-5.jpeg",
    6: "https://astrologyytoday2024.com/images/c-6.jpeg",
    7: "https://astrologyytoday2024.com/images/c-7.jpeg",
    8: "https://astrologyytoday2024.com/images/c-8.jpeg",
    9: "https://astrologyytoday2024.com/images/c-9.jpeg",
    10: "https://astrologyytoday2024.com/images/c-10.jpeg",
    11: "https://astrologyytoday2024.com/images/c-11.jpeg",
    12: "https://astrologyytoday2024.com/images/c-12.jpeg",
    13: "https://astrologyytoday2024.com/images/c-13.jpeg",
    14: "https://astrologyytoday2024.com/images/c-14.jpeg",
    15: "https://astrologyytoday2024.com/images/c-15.jpeg",
    16: "https://astrologyytoday2024.com/images/c-16.jpeg",
    17: "https://astrologyytoday2024.com/images/c-17.jpeg",
    18: "https://astrologyytoday2024.com/images/c-18.jpeg",
    19: "https://astrologyytoday2024.com/images/c-19.jpeg",
    20: "https://astrologyytoday2024.com/images/c-20.jpeg",
};

const Home = () => {
    const [cardClicked, setCardClicked] = useState(false);
    const [name, setName] = useState("");
    const [date, setDate] = useState("");
    const [genre, setGenre] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [steps, setSteps] = useState(0);
    const [flippedCards, setFlippedCards] = useState([]);
    const [transitionState, setTransitionState] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleCardClick = (cardId) => {
        if (flippedCards.includes(cardId)) {
            return;
        }
        setFlippedCards([...flippedCards, cardId]);
        setCardClicked(true);
        setSteps(steps + 1);
        setTransitionState(false);
    }

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === "Enter") {
                handleNextCard();
            }
        }

        window.addEventListener("keydown", handleKeyPress);

        return () => {
            window.removeEventListener("keydown", handleKeyPress);
        }
    }, [name, date, genre, phone, email, steps]);

    const handleNextCard = () => {
        if (name === "" && steps === 1) {
            alert("Veuillez entrer votre prénom");
            return;
        } else if (date === "" && steps === 2) {
            alert("Veuillez entrer votre date de naissance");
            return;
        } else if (genre === "" && steps === 3) {
            alert("Veuillez choisir votre genre");
            return;
        } else if (phone === "" && steps === 4) {
            alert("Veuillez entrer votre numéro de téléphone");
            return;
        } else if (steps === 5) {
            handleFinalSubmit();
            return;
        }
        setTransitionState(true);
        setCardClicked(false);
    }

    const handleFinalSubmit = () => {
        if (email === "") {
            alert("Veuillez entrer votre adresse email");
            return;
        }
        if (!email.includes("@") || !email.includes(".")) {
            alert("Veuillez entrer une adresse email valide");
            return;
        }
        const xhr = new XMLHttpRequest();
        xhr.open("POST", `https://www.irina-voyance.fr/atrail.php?query=saveDB&track=LP1&name=${name}&partner=undefined&birth=${date}&quinevapas=undefined&emailName=${email}&question=undefined&general=undefined&gender=${genre}&phoneName=${phone}`, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    console.log(xhr.responseText);
                    window.location.href = "/LP1/thankyou"
                } else {
                    console.log("Error", xhr.statusText);
                    alert("Une erreur est survenue, veuillez réessayer plus tard");
                }
            }
        };
        xhr.send();
        setSuccess(true);
    }

    const renderStepContent = () => {
        if (transitionState) {
            return <div className={"content"}>
                <h1 className={"big-description"}>Sélectionnez une nouvelle carte, préparez-vous à l'émerveillement !</h1>
                <p className={"small-description"}>Partagez avec moi votre histoire amoureuse, plongez-moi dans les détails captivants!</p>
            </div>
        }
        switch (steps) {
            case 1:
                return <NameInput name={name} setName={setName} />;
            case 2:
                return <DateInput date={date} setDate={setDate} />;
            case 3:
                return <GenreInput genre={genre} setGenre={setGenre} />;
            case 4:
                return <PhoneInput phone={phone} setPhone={setPhone} />;
            case 5:
                return <EmailInput email={email} setEmail={setEmail} handleFinalSubmit={handleFinalSubmit}/>;
            default:
                return <div className={"content"}>
                    <h1 className={"big-description"}>Sélectionnez une nouvelle carte, préparez-vous à l'émerveillement !</h1>
                    <p className={"small-description"}>Partagez avec moi votre histoire amoureuse, plongez-moi dans les détails captivants!</p>
                </div>;
        }
    }

    function getCardImage() {
        return cardsImages[Math.floor(Math.random() * 20)];
    }

    return (
        <>
            <div className={"header"}>
                <img className="header-image" src={require("../assets/irina_pp.png")} alt="logo" />
                <div className={"header-text"}>
                    <h1 className="header-title">Irina</h1>
                    <h3 className="header-subtitle">La voyante préférée des Stars</h3>
                </div>
            </div>
            {steps !== 0 ? (
                <>
                    {renderStepContent()}
                    {cardClicked && steps !== 5 ? (
                        <>
                            <button className={"button"} onClick={handleNextCard}>CARTE SUIVANTE</button>
                        </>
                    ) : (
                        <>
                        </>
                    )}
                </>
            ) : (
                <>
                    <div className="content">
                        <h1 className="big-description">
                            Bienvenue, âmes lumineuses. Je suis Irina, prête à éclairer votre trajectoire céleste.
                        </h1>
                        <p className="small-description">
                            Permettez-moi de vous dévoiler les secrets de votre destin. Prenez une carte, elle révélera les énigmes qui habitent votre esprit.
                        </p>
                    </div>
                </>
            )}
            <div className="cards">
                {[...Array(6)].map((_, index) => (
                    <Card
                        key={index}
                        id={index}
                        image={getCardImage()}
                        onClick={() => handleCardClick(index)}
                        disableClick={cardClicked || flippedCards.includes(index)}
                        higher={index % 2 === 0}
                    />
                ))}
            </div>
        </>
    );
}

export default Home;